<template>
    <div>
        <h4>SIMPLY SIX</h4>
        <p>
            6p News + 2p Cal<br />
            2 - 11x17 sheet of paper, folded in half.<br />
            Color only<br />
            2, 3, or 4 pages of custom-designed content<br />
            2pg of Corwin content -filler spread<br />
            Newsletter Qty must be equal to Calendar Qty - Calendar is printed
            in newsletter and pricing is based off news qty.<br />
            includes up to 3700 characters. Reaching to following “break points”
            adds an additional $55:<br />
            3701-6000 - adds $55<br />
            6001-8500 - adds $110<br />
            Uses Special Calendar pricing (each calendar adds $45 to News
            pricing. )
        </p>
        <table class="w-full" style="max-width: 500px">
            <thead>
                <tr>
                    <td class="text-center">Quantity</td>
                    <td class="text-center">
                        6 Pages<br />
                        up to 3700
                    </td>
                    <td class="text-center">Each Calendar</td>
                </tr>
            </thead>
            <tbody>
                <tr v-for="row in computedPrices">
                    <td class="text-center">{{ row.quantity }}</td>
                    <td v-for="price in row.prices">
                        <div class="el-input el-input--minimal-padding">
                            <money
                                v-model.number="price.price"
                                v-bind="money"
                                :disabled="!can(Permissions.EDIT_PRICING)"
                                class="text-right el-input__inner"
                            />
                        </div>
                    </td>
                </tr>
            </tbody>
        </table>
    </div>
</template>

<script>
import { mapState } from "vuex";
import * as ColorTypes from "../../../constants/color-types";
import { Money, VMoney } from "v-money";
import auth from "@/mixins/auth";

export default {
    mixins: [auth],
    props: {
        form: {
            type: Object,
            required: true,
        },
    },
    directives: { money: VMoney },
    components: {
        Money,
    },
    data() {
        return {
            newsletter_type_id: 3,
            ColorTypes,
            money: {
                decimal: ".",
                thousands: ",",
                prefix: "$ ",
                suffix: "",
                precision: 2,
                masked: true,
            },
        };
    },
    computed: {
        ...mapState({
            sizes: (state) => state.sizes.data,
            prices: (state) => state.prices.data,
            pricing: (state) => state.config.settings.pricing,
        }),
        computedPrices() {
            let prices = [];
            let base = {
                ...this.basePriceAttributes,
                newsletter_type_id: this.newsletter_type_id,
            };
            prices = _.map(
                this.pricing.quantities.calendars.flats,
                (quantity) => {
                    let prices = [];

                    let price = _.find(this.form.prices, {
                        ...base,
                        quantity,
                    });
                    if (price) {
                        prices.push(price);
                    }

                    price = _.find(this.form.prices, {
                        ...base,
                        quantity,
                        each_calendar: true,
                    });
                    if (price) {
                        prices.push(price);
                    }
                    return {
                        quantity,
                        prices,
                    };
                }
            ).filter((item) => {
                return !!item;
            });
            return prices;
        },
    },
};
</script>

<style scoped></style>
